import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function ProductReveal() {
  const features = ['Todo el programa', 'Todo resuelto'];
  return <section className="py-12 px-4 max-w-5xl mx-auto text-center" data-id="element-270">
      <FadeIn data-id="element-271">
        <div className="inline-block mb-6" data-id="element-272">
          <span className="text-6xl" data-id="element-273">🏆</span>
        </div>
        <h2 className="text-4xl md:text-6xl font-black mb-6 text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-cyan-600" data-id="element-274">
          MEGAPACK PSICOLOGÍA LISTA
        </h2>
        <p className="text-2xl md:text-3xl font-bold text-gray-200 mb-10" data-id="element-275">
          6 Tomos + 6 Bonos — 540+ páginas
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-276">
        <div className="bg-gray-900/50 border border-sky-900/50 rounded-2xl p-8 max-w-3xl mx-auto text-left flex justify-center" data-id="element-277">
          <ul className="space-y-4" data-id="element-278">
            {features.map((feature, index) => <li key={index} className="flex items-center gap-3" data-id="element-279">
                <CheckCircle2 className="text-sky-500 shrink-0" size={24} data-id="element-280" />
                <span className="text-lg text-gray-200 font-medium" data-id="element-281">
                  {feature}
                </span>
              </li>)}
          </ul>
        </div>
      </FadeIn>
    </section>;
}